<template>
    <div class="wrapper" v-if="value">
        {{content}}
    </div>
</template>

<script>
    export default {
        name: 'Alert',
        props: {
            content: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                value: false
            };
        }
    };
</script>

<style scoped>
.wrapper {
    position: fixed;
    top: 50%;
    left: 50%;
    white-space: nowrap;
    transform: translate(-50%, -50%);
    z-index: 101;
    line-height: 0.8rem;
    padding: 0 0.2rem;
    background: #000;
    opacity: 0.8;
    color: #fff;
    font-size: 0.3rem;

}
</style>